import { usePopoverState } from 'ariakit/popover';

const usePopoverStateAlpha = props => {
  const state = usePopoverState({
    gutter: 12,
    ...props
  });
  return state;
};

export { usePopoverStateAlpha };
